export const state = () => ({
    selectSyndicator: {},
    Result:'',
    editSyndicator:{},
})
